/* Lopedro redesign — header, project stage, studio hover, add to cart, cart lines. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Header menu ---------- */
  function initMenu() {
    var burger = $('.lp-burger'), menu = $('.lp-menu');
    if (!burger || !menu) return;
    var set = function (open) { menu.hidden = !open; burger.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    burger.addEventListener('click', function () { set(menu.hidden); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) set(false); });
    window.matchMedia('(max-width: 760px)').addEventListener('change', function (m) { if (!m.matches) set(false); });
  }

  /* Update the Cart (n) links and the mobile badge after a cart change. */
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-cart-link]').forEach(function (el) { el.hidden = n < 1; });
    $$('[data-cart-badge]').forEach(function (el) { el.hidden = n < 1; });
  }

  /* ---------- Project / product stage: native scrolling with snap points ----------
     Slides sit one after another like a page and move 1:1 with the finger or trackpad (the browser supplies the
     momentum), then snap to the nearest slide without skipping. A copy of the first slide at the end makes it loop.
     The project title and the Scroll cue stay fixed; the title hides over the mobile text slide. */
  function initStage() {
    var root = $('[data-stage]'); if (!root) return;
    var ring = $('[data-ring]'), arc = $('[data-arc]'), menu = $('.lp-menu');
    var title = $('[data-stage-title]', root), cue = $('[data-cue]', root), cueLine = cue && cue.querySelector('i');
    var host = root.parentNode;
    if (title) host.appendChild(title);
    if (cue) host.appendChild(cue);
    var C = 106.81, titleV = 0, lastT = 0, idle = 0, clone = null, slides = [], n = 0, textIdx = -1;
    var textFirst = root.hasAttribute('data-text-first');
    var textSlide = $('.lp-slide.lp-mobile-only', root);
    /* Mobile text slide (rendered last): first on project pages, second on product pages. */
    if (textSlide) {
      var photos = $$('.lp-slide', root).filter(function (s) { return s !== textSlide; });
      if (photos.length) root.insertBefore(textSlide, textFirst ? photos[0] : (photos[1] || null));
    }
    var H = function () { return root.clientHeight || 1; };
    var fitText = function () {
      $$('.lp-textslide', root).forEach(function (ts) {
        var inner = ts.firstElementChild; if (!inner || !ts.getClientRects().length) return;
        inner.style.removeProperty('--k');
        var cs = getComputedStyle(ts), avail = ts.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
        for (var k = 1; k > 0.55 && inner.scrollHeight > avail; k -= 0.05) inner.style.setProperty('--k', k.toFixed(2));
      });
    };
    var build = function () {
      if (clone) { clone.remove(); clone = null; }
      fitText();
      slides = $$('.lp-slide', root).filter(function (s) { return getComputedStyle(s).display !== 'none'; });
      n = slides.length; textIdx = textSlide ? slides.indexOf(textSlide) : -1;
      if (n > 1) { clone = slides[0].cloneNode(true); clone.setAttribute('data-clone', ''); clone.setAttribute('aria-hidden', 'true'); root.appendChild(clone); }
    };
    build(); root.scrollTop = 0;
    window.matchMedia('(max-width: 760px)').addEventListener('change', function () { build(); root.scrollTop = 0; });
    window.addEventListener('resize', fitText);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { build(); });
    var go = function (d) { root.scrollBy({ top: d * H(), behavior: 'smooth' }); };
    var settle = function () {
      if (n > 1 && root.scrollTop >= n * H() - 2) { root.style.scrollBehavior = 'auto'; root.scrollTop -= n * H(); root.style.scrollBehavior = ''; }
    };
    root.addEventListener('scroll', function () { clearTimeout(idle); idle = setTimeout(settle, 140); }, { passive: true });
    if ('onscrollend' in window) root.addEventListener('scrollend', settle);
    if (cue) cue.addEventListener('click', function () { go(1); });
    window.addEventListener('keydown', function (ev) {
      if (menu && !menu.hidden) return;
      if (ev.target.closest && ev.target.closest('input,select,textarea,button')) return;
      if (['ArrowDown', 'PageDown', ' '].indexOf(ev.key) > -1) { ev.preventDefault(); go(1); }
      if (['ArrowUp', 'PageUp'].indexOf(ev.key) > -1) { ev.preventDefault(); go(-1); }
    });
    var near = function (p, i) { var d = Math.abs(p - i); if (i === 0 && n > 1) d = Math.min(d, Math.abs(p - n)); return d; };
    function frame(now) {
      var dt = Math.min(0.05, (now - (lastT || now)) / 1000); lastT = now;
      var p = root.scrollTop / H(), h = window.innerHeight;
      if (title) {
        /* drops from mid-screen into its corner once on load, then stays put */
        titleV = titleV > 0.999 ? 1 : titleV + (1 - titleV) * (1 - Math.exp(-dt / 0.15));
        title.style.transform = 'translateY(' + (-(1 - titleV) * (Math.max(h, 480) * 0.5 - 60)).toFixed(1) + 'px)';
        var hide = 0;
        if (textIdx > -1) { var tj = Math.min(1, Math.max(0, (0.5 - near(p, textIdx)) / 0.22)); hide = tj * tj * (3 - 2 * tj); }
        title.style.opacity = (1 - hide).toFixed(3);
      }
      if (cue) {
        var dFirst = textIdx === 0 ? near(p, 0) : 1, co = Math.max(0, 1 - dFirst * 3);
        cue.style.opacity = co.toFixed(3); cue.style.pointerEvents = co > 0.1 ? 'auto' : 'none';
        if (co > 0 && cueLine) { var tc = (now % 1800) / 1800; cueLine.style.transform = 'scaleY(' + (0.25 + 0.75 * Math.sin(Math.PI * tc)).toFixed(3) + ')'; cueLine.style.transformOrigin = tc < 0.5 ? 'top' : 'bottom'; }
      }
      if (ring && arc) {
        ring.style.opacity = n > 1 ? '1' : '0';
        var tot = Math.max(1, n), seg = C / tot, wpos = n ? ((p % n) + n) % n : 0;
        arc.style.strokeDasharray = seg.toFixed(2) + ' ' + (C - seg).toFixed(2);
        arc.style.strokeDashoffset = (-wpos * seg).toFixed(2);
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Studio: hover a row to preview its photo ---------- */
  function initStudio() {
    var list = $('[data-studio]'), img = $('[data-preview]'), link = $('[data-preview-link]'); if (!list) return;
    var preload = function () { $$('.lp-row[data-img]', list).forEach(function (r) { new Image().src = r.dataset.img; }); };
    if (window.matchMedia('(min-width: 761px)').matches) { if ('requestIdleCallback' in window) requestIdleCallback(preload); else setTimeout(preload, 800); }
    /* Fit the whole list on one screen: shrink rows (--k) until nothing overflows. */
    var fit = function () {
      if (!document.body.classList.contains('lp-body--fit') || !window.matchMedia('(min-width: 761px)').matches) { list.style.removeProperty('--k'); return; }
      list.style.setProperty('--k', '1');
      if (list.scrollHeight <= list.clientHeight + 1) return;
      var lo = 0.3, hi = 1;
      for (var i = 0; i < 12; i++) {
        var mid = (lo + hi) / 2; list.style.setProperty('--k', mid.toFixed(4));
        if (list.scrollHeight <= list.clientHeight + 1) lo = mid; else hi = mid;
      }
      list.style.setProperty('--k', lo.toFixed(4));
    };
    var fitTimer; fit();
    window.addEventListener('resize', function () { clearTimeout(fitTimer); fitTimer = setTimeout(fit, 60); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    /* Mobile: no hover, so the row passing just below the pinned preview photo becomes the active one. */
    var mq = window.matchMedia('(max-width: 760px)'), pv = $('.lp-preview'), arc = $('[data-arc]'), activeRow = null, ticking = false, userScrolled = false;
    /* Loop, as on the landing page: a copy of the whole list follows the end; once a copied row settles
       under the photo, jump (invisibly) back to the same real row. */
    var sc = $('.lp-studio') || window, nReal = $$('.lp-row', list).length, silent = false, settleT;
    if (mq.matches && pv) {
      $$('.lp-group', list).forEach(function (g) {
        var c = g.cloneNode(true); c.setAttribute('data-loop-copy', ''); c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        $$('a', c).forEach(function (a) { a.tabIndex = -1; }); list.appendChild(c);
      });
    }
    var loopBack = function () {
      if (!activeRow || !activeRow.closest('[data-loop-copy]')) return;
      var rows = $$('.lp-row', list), i = rows.indexOf(activeRow) - nReal; if (i < 0) return;
      var period = rows[nReal].getBoundingClientRect().top - rows[0].getBoundingClientRect().top;
      silent = true; sc.scrollTo({ top: sc.scrollTop - period, behavior: 'instant' }); pick(); silent = false;
    };
    var settle = function () { clearTimeout(settleT); settleT = setTimeout(loopBack, 'onscrollend' in window ? 0 : 160); };
    if ('onscrollend' in window) sc.addEventListener('scrollend', settle); else sc.addEventListener('scroll', settle, { passive: true });
    /* Haptic tick per row: the Vibration API (Android); on iOS 18+ Safari, toggling a hidden switch control ticks. */
    var sw = document.createElement('label'); sw.setAttribute('aria-hidden', 'true');
    sw.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none';
    sw.innerHTML = '<input type="checkbox" switch tabindex="-1">'; document.body.appendChild(sw);
    var tick = function () { try { if (navigator.vibrate) navigator.vibrate(6); else sw.click(); } catch (e) {} };
    ['touchstart', 'wheel'].forEach(function (t) { window.addEventListener(t, function () { userScrolled = true; }, { passive: true }); });
    var setActive = function (row) {
      if (!row || row === activeRow) return;
      if (activeRow && userScrolled && !silent) tick();
      activeRow = row;
      $$('.lp-row.is-hover', list).forEach(function (r) { r.classList.remove('is-hover'); });
      row.classList.add('is-hover'); list.classList.add('is-hovering');
      if (img && row.dataset.img) { img.src = row.dataset.img; img.hidden = false; }
      if (link) link.href = row.href;
    };
    var pick = function () {
      ticking = false; if (!mq.matches || !pv) return;
      /* rows snap with their top edge 18px below the photo (scroll-margin-top in lopedro.css) */
      var line = pv.getBoundingClientRect().bottom + 18, best = null, bestD = 1e9;
      var rows = $$('.lp-row', list), tops = rows.map(function (r) { return r.getBoundingClientRect().top; });
      tops.forEach(function (t, i) { var d = Math.abs(t - line); if (d < bestD) { bestD = d; best = rows[i]; } });
      setActive(best);
      /* progress ring, as on the other scrolls: one segment per row, gliding continuously between rows */
      if (arc && rows.length > 1) {
        var n = rows.length, pos = 0;
        for (var i = 0; i < n - 1; i++) { if (line >= tops[i]) pos = i + Math.min(1, (line - tops[i]) / Math.max(1, tops[i + 1] - tops[i])); }
        var seg = 106.81 / nReal; pos = pos % nReal;
        arc.style.strokeDasharray = seg.toFixed(2) + ' ' + (106.81 - seg).toFixed(2);
        arc.style.strokeDashoffset = (-pos * seg).toFixed(2);
      }
    };
    sc.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(pick); } }, { passive: true });
    window.addEventListener('resize', pick); pick();
    if (mq.matches && 'requestIdleCallback' in window) requestIdleCallback(function () { $$('.lp-row[data-img]', list).forEach(function (r) { new Image().src = r.dataset.img; }); });
    $$('.lp-row', list).forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        $$('.lp-row.is-hover', list).forEach(function (r) { r.classList.remove('is-hover'); });
        row.classList.add('is-hover'); list.classList.add('is-hovering');
        if (img && row.dataset.img) { img.src = row.dataset.img; img.hidden = false; }
        if (link) link.href = row.href;
      });
    });
  }

  /* ---------- Product: add to cart without leaving the page ----------
     The info block is rendered twice (beside the first photo, and as the mobile final slide). */
  function initProduct() {
    var blocks = $$('[data-product-info]'); if (!blocks.length) return;
    var qtyOf = function (id, cart) { var q = 0; cart.items.forEach(function (it) { if (String(it.variant_id) === String(id)) q += it.quantity; }); return q; };
    blocks.forEach(function (box) {
      var form = $('[data-product-form]', box); if (!form) return;
      var btn = $('[data-add]', form), err = $('[data-err]', form), sel = $('[data-variant]', form), price = $('[data-price]', box);
      var variants = []; try { variants = JSON.parse(($('[data-variants]', form) || {}).textContent || '[]'); } catch (e) {}
      var refresh = function (v) {
        if (!btn || !v) return;
        if (price) price.textContent = v.price_label;
        btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : btn.dataset.sold;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { var q = qtyOf(v.id, c); if (q && v.available) btn.textContent = btn.dataset.added.replace('[n]', q); }).catch(function () {});
      };
      if (sel) sel.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === sel.value; })[0]; refresh(v);
        var u = new URL(location.href); u.searchParams.set('variant', sel.value); history.replaceState(null, '', u);
      });
      form.addEventListener('submit', function (ev) {
        ev.preventDefault(); if (!btn || btn.disabled) return;
        btn.disabled = true; if (err) err.hidden = true;
        var id = new FormData(form).get('id');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (c) {
            setCartCount(c.item_count);
            $$('[data-product-form]').forEach(function (f) { var b = $('[data-add]', f); if (b && String(new FormData(f).get('id')) === String(id)) b.textContent = b.dataset.added.replace('[n]', qtyOf(id, c)); });
          })
          .catch(function (e) { if (err) { err.textContent = (e && (e.description || e.message)) || 'Could not add to cart.'; err.hidden = false; } })
          .then(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------- Cart: quantity ± and remove via /cart/change.js ---------- */
  function initCart() {
    var root = $('[data-cart]'); if (!root) return;
    root.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-line]'); if (!b) return;
      ev.preventDefault();
      var lines = $('.lp-lines', root); if (lines) lines.classList.add('is-busy');
      var sid = root.dataset.section;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.qty, sections: [sid] }) })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          setCartCount(c.item_count);
          var html = c.sections && c.sections[sid];
          if (html) { var d = document.createElement('div'); d.innerHTML = html; var fresh = d.querySelector('[data-cart]'); if (fresh) { root.innerHTML = fresh.innerHTML; return; } }
          location.reload();
        })
        .catch(function () { location.reload(); });
    });
  }

  /* ---------- Studio on mobile: all projects in one grid; pick the column count that gives the largest photos.
     Pinch zooms the grid (1–5×) around the fingers, one finger pans while zoomed, a tap opens the project. ---------- */
  function initMGrid() {
    var box = $('[data-mgrid]'); if (!box) return;
    var grid = $('.lp-mgrid-in', box) || box;
    var fit = function () {
      if (!box.getClientRects().length) return;
      var n = grid.children.length, W = box.clientWidth, H = box.clientHeight, gx = 8, gy = 10, title = 0, best = 4, bestSize = 0;
      for (var c = 2; c <= 6; c++) {
        var r = Math.ceil(n / c), w = (W - (c - 1) * gx) / c, h = (H - (r - 1) * gy) / r - title, size = Math.min(w, h * 1.1);
        if (size > bestSize) { bestSize = size; best = c; }
      }
      grid.style.setProperty('--cols', best); grid.style.setProperty('--rows', Math.ceil(n / best));
    };
    var s = 1, tx = 0, ty = 0, pinch = null, pan = null, moved = false, sharp = false, raf = 0, track = [];
    var dims = function () { return { W: box.clientWidth, H: box.clientHeight }; };
    /* Soft limits while a finger is down: past an edge or zoom limit the grid follows with resistance
       instead of stopping dead; the snap on release brings it back. */
    var soft = function (v, lo, hi, k) { return v < lo ? lo - (lo - v) * k : v > hi ? hi + (v - hi) * k : v; };
    var hard = function () {
      var d = dims(); s = Math.max(1, Math.min(5, s));
      tx = Math.min(0, Math.max(d.W - d.W * s, tx)); ty = Math.min(0, Math.max(d.H - d.H * s, ty));
    };
    var render = function () {
      raf = 0;
      grid.style.transform = (s === 1 && !tx && !ty) ? '' : 'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')';
      if (s > 1.6 && !sharp) { sharp = true; $$('img[data-zoom-sizes]', grid).forEach(function (i) { i.sizes = i.getAttribute('data-zoom-sizes'); }); }
    };
    /* One transform update per frame, however many touch events arrive. */
    var schedule = function () { if (!raf) raf = requestAnimationFrame(render); };
    var apply = function () { hard(); if (raf) { cancelAnimationFrame(raf); raf = 0; } render(); };
    var rel = function (t) { var r = box.getBoundingClientRect(); return { x: t.clientX - r.left, y: t.clientY - r.top }; };
    var mid = function (a, b) { var p = rel(a), q = rel(b); return { x: (p.x + q.x) / 2, y: (p.y + q.y) / 2, d: Math.hypot(p.x - q.x, p.y - q.y) || 1 }; };
    /* Grabbing mid-snap: continue from where the grid actually is, not from the snap target. */
    var grab = function () {
      if (!grid.classList.contains('is-snapping')) return;
      var m = getComputedStyle(grid).transform;
      if (m && m !== 'none') { var v = m.match(/-?[\d.]+(?:e-?\d+)?/g).map(Number); s = v[0]; tx = v[4]; ty = v[5]; }
      grid.classList.remove('is-snapping'); render();
    };
    box.addEventListener('touchstart', function (ev) {
      grab();
      if (ev.touches.length >= 2) { var m = mid(ev.touches[0], ev.touches[1]); pinch = { d: m.d, s: s, px: (m.x - tx) / s, py: (m.y - ty) / s }; pan = null; moved = true; }
      else if (ev.touches.length === 1) { var p = rel(ev.touches[0]); pan = { x: p.x, y: p.y, tx: tx, ty: ty }; pinch = null; moved = false; track = [{ x: p.x, y: p.y, t: performance.now() }]; }
    }, { passive: true });
    box.addEventListener('touchmove', function (ev) {
      var d = dims();
      if (pinch && ev.touches.length >= 2) {
        ev.preventDefault();
        var m = mid(ev.touches[0], ev.touches[1]);
        s = soft(pinch.s * m.d / pinch.d, 1, 5, 0.35); tx = m.x - pinch.px * s; ty = m.y - pinch.py * s;
        tx = soft(tx, Math.min(0, d.W - d.W * s), 0, 0.35); ty = soft(ty, Math.min(0, d.H - d.H * s), 0, 0.35); schedule();
      } else if (pan && ev.touches.length === 1) {
        var p = rel(ev.touches[0]), dx = p.x - pan.x, dy = p.y - pan.y, now = performance.now();
        if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
        track.push({ x: p.x, y: p.y, t: now }); while (track.length > 2 && now - track[0].t > 100) track.shift();
        if (s > 1) { ev.preventDefault(); tx = soft(pan.tx + dx, Math.min(0, d.W - d.W * s), 0, 0.35); ty = soft(pan.ty + dy, Math.min(0, d.H - d.H * s), 0, 0.35); schedule(); }
      }
    }, { passive: false });
    /* Lock into the grid when the fingers lift: a whole number of columns fills the width exactly and the view
       starts on a column/row boundary (at the bottom edge it aligns to the last row instead). Nothing is hidden.
       A flick carries on in its direction first (velocity projection), so the grid settles where it was heading. */
    var snap = function (vx, vy) {
      var W = box.clientWidth, H = box.clientHeight, cs = getComputedStyle(grid);
      var C = parseInt(grid.style.getPropertyValue('--cols'), 10) || 4, R = parseInt(grid.style.getPropertyValue('--rows'), 10) || 6;
      var gx = parseFloat(cs.columnGap) || 8, gy = parseFloat(cs.rowGap) || 10;
      var cw = (W - (C - 1) * gx) / C, ch = (H - (R - 1) * gy) / R, pxs = cw + gx, pys = ch + gy;
      var k = Math.max(1, Math.min(C, Math.round(W / (Math.max(1, Math.min(5, s)) * pxs))));
      if (raf) { cancelAnimationFrame(raf); raf = 0; render(); }
      void grid.offsetWidth; grid.classList.add('is-snapping');
      if (k >= C) { s = 1; tx = 0; ty = 0; apply(); return; }
      var ns = W / (k * cw + (k - 1) * gx);
      var ptx = tx + (vx || 0) * 220, pty = ty + (vy || 0) * 220;
      var col = Math.max(0, Math.min(C - k, Math.round((-ptx / s) / pxs)));
      var rowsFit = Math.max(1, Math.floor((H / ns + gy) / pys));
      var row = Math.max(0, Math.min(Math.max(0, R - rowsFit), Math.round((-pty / s) / pys)));
      /* Never frame only empty cells (the last row can be short): step left/up until a tile is in view. */
      var n = grid.children.length;
      while ((row * C + col) >= n && (col > 0 || row > 0)) { if (col > 0) col--; else row--; }
      s = ns; tx = -col * pxs * s; ty = -row * pys * s; apply();
    };
    box.addEventListener('touchend', function (ev) {
      if (ev.touches.length === 1) { var p = rel(ev.touches[0]); pan = { x: p.x, y: p.y, tx: tx, ty: ty }; pinch = null; track = [{ x: p.x, y: p.y, t: performance.now() }]; }
      else if (!ev.touches.length) {
        var was = pinch || (pan && moved), vx = 0, vy = 0;
        if (pan && track.length > 1) { var a = track[0], b = track[track.length - 1], dt = Math.max(16, b.t - a.t); if (performance.now() - b.t < 80) { vx = (b.x - a.x) / dt; vy = (b.y - a.y) / dt; } }
        pinch = null; pan = null; if (was || s > 1) snap(vx, vy);
      }
    });
    /* After a pinch or drag, the lifting finger must not open a project. */
    box.addEventListener('click', function (ev) { if (moved) { ev.preventDefault(); ev.stopPropagation(); moved = false; } }, true);
    ['gesturestart', 'gesturechange'].forEach(function (t) { box.addEventListener(t, function (ev) { ev.preventDefault(); }); });
    fit(); var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { grid.classList.remove('is-snapping'); s = 1; tx = 0; ty = 0; apply(); fit(); }, 60); });
  }

  /* ---------- Shop orbit (desktop): one product large in the centre, the rest floating around it in a loose ring.
     The centre image sits on a frosted glass card (with its caption); ring images that overlap it blur behind the glass.
     Each image is animated in polar
     coordinates around the centre, so on a change the ring orbits rather than cutting across; every image uses its own
     critically damped timing (no bounce) and a layered drift, so the motion feels organic rather than in lockstep.
     Clicking a product brings it to the centre and reveals its title and price; clicking the centred product opens it. ---------- */
  function initOrbit() {
    var box = $('[data-orbit]'); if (!box) return;
    var mq = window.matchMedia('(min-width: 761px)'), still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = $$('.lp-orb', box), labels = $$('.lp-orb-t', box), n = els.length; if (!n) return;
    var rnd = function (k) { var x = Math.sin(k * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); };
    var center = 0, ring = []; for (var r = 1; r < n; r++) ring.push(r);
    var W = 0, H = 0, base = 1, cx = 0, cy = 0, lock = 0;
    var CAP = 58, PAD = 64, glass = document.createElement('div');   /* caption room and glass margin around the centre image */
    glass.className = 'lp-orb-glass'; glass.style.setProperty('--f', PAD + 'px'); glass.setAttribute('aria-hidden', 'true'); box.appendChild(glass);
    var it = els.map(function (el, i) {
      return { el: el, lb: labels[i], ar: parseFloat(el.dataset.ar) || .8,
        a: 0, av: 0, d: 0, dv: 0, s: .3, sv: 0, ta: 0, td: 0, ts: .3,
        T: .45 + rnd(i + 17) * .4,                                    /* own pace */
        /* idle wander: every few seconds (irregularly) each product picks a new random resting point and tilt nearby
           and glides there on a slow, bounce-free spring; no waves, so it never repeats or falls into step */
        amp: 7 + rnd(i + 11) * 7, rot: 1.2 + rnd(i + 12) * 1.4, WT: 1.5 + rnd(i + 7) * 1.1, r: 0, rv: 0,
        wx: 0, wxv: 0, wy: 0, wyv: 0, wr: 0, wrv: 0, gx: 0, gy: 0, gr: 0, next: 0 };
    });
    /* Resting layout: the centre product large, the others on a loose ring that overlaps it at the edges;
       the overlaps sit behind a frosted glass card around the centre image. */
    var targets = function () {
      W = box.clientWidth; H = box.clientHeight; if (!W || !H) return;
      cx = W / 2; cy = H / 2 - CAP / 3;
      var m = ring.length;
      var P = it.map(function (o, i) {
        var h, x, y;
        if (i === center) { h = H * .52; if (h * o.ar > W * .34) h = W * .34 / o.ar; x = cx; y = cy; }
        else {
          var k = ring.indexOf(i), ang = -Math.PI / 2 + (k + .5) * 2 * Math.PI / m + (rnd(k) - .5) * .5;
          h = H * (.22 + rnd(k + 20) * .09); if (h * o.ar > W * .17) h = W * .17 / o.ar;
          var rx = Math.min(W * .27, W / 2 - h * o.ar / 2 - 24), ry = Math.min(H * .31, H / 2 - h / 2 - 24);
          x = cx + Math.cos(ang) * rx * (.92 + rnd(k + 40) * .12); y = cy + Math.sin(ang) * ry * (.9 + rnd(k + 60) * .14);
        }
        return { i: i, x: x, y: y, h: h, fixed: i === center };
      });
      base = P[center].h;
      P.forEach(function (q) {
        var o = it[q.i], dx = q.x - cx, dy = q.y - cy;
        o.td = Math.hypot(dx, dy); if (o.td > .5) o.ta = Math.atan2(dy, dx);
        o.ts = q.h / base; o.z = q.fixed ? 5 : 2;
        o.el.style.width = (base * o.ar).toFixed(1) + 'px'; o.el.style.height = base.toFixed(1) + 'px';
        o.el.style.zIndex = o.z; o.lb.style.zIndex = o.z; o.lb.classList.toggle('is-center', q.fixed); o.el.classList.toggle('is-center', q.fixed);
      });
    };
    var focus = function (i) {
      if (i === center || performance.now() < lock) return;
      var k = ring.indexOf(i); ring[k] = center; center = i;
      ring.unshift(ring.pop());            /* the ring turns one step: every image moves */
      lock = performance.now() + 450;
      var inA = it[i].a; targets(); it[i].ta = inA;   /* the incoming image heads straight in */
    };
    /* critically damped spring: eases in and settles without overshoot, independent of frame rate */
    var damp = function (o, key, target, T, dt) {
      var v = key + 'v', w = 2 / T, x = w * dt, e = 1 / (1 + x + .48 * x * x + .235 * x * x * x), c = o[key] - target, t = (o[v] + w * c) * dt;
      o[v] = (o[v] - w * t) * e; o[key] = target + (c + t) * e;
    };
    var gauss = function () { var u = 1 - Math.random(), v = Math.random(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(6.2832 * v); };
    var wrap = function (a) { while (a > Math.PI) a -= 2 * Math.PI; while (a < -Math.PI) a += 2 * Math.PI; return a; };
    var last = 0, first = true;
    var frame = function (now) {
      requestAnimationFrame(frame);
      if (!mq.matches || !W) { last = now; return; }
      var dt = Math.min(.05, Math.max(.001, (now - last) / 1000)); last = now;
      it.forEach(function (o, i) {
        if (first) {
          o.a = o.ta; o.d = o.td; o.s = o.ts;
          /* start scattered, each on its own clock, so no two begin a move together */
          o.wx = o.gx = gauss() * o.amp * .7; o.wy = o.gy = gauss() * o.amp * .6; o.wr = o.gr = o.r = gauss() * o.rot * .7;
          o.next = now + 600 + Math.random() * 5000;
        }
        o.a = o.ta + wrap(o.a - o.ta);                                  /* orbit the short way round */
        if (still) { o.a = o.ta; o.d = o.td; o.s = o.ts; }   /* reduce motion: swaps happen without the glide */
        damp(o, 'a', o.ta, o.T, dt); damp(o, 'd', o.td, o.T, dt); damp(o, 's', o.ts, o.T * .9, dt);
        if (still) { o.gx = o.gy = o.gr = 0; o.next = Infinity; }   /* reduce motion: no idle drift or tilt */
        if (now >= o.next) {
          var cl = function (v) { return Math.max(-1.8, Math.min(1.8, v)); };
          o.gx = cl(gauss()) * o.amp; o.gy = cl(gauss()) * o.amp * .85; o.gr = cl(gauss()) * o.rot;
          o.next = now + 2500 + Math.random() * 4500;
        }
        damp(o, 'wx', o.gx, o.WT, dt); damp(o, 'wy', o.gy, o.WT * 1.1, dt); damp(o, 'wr', o.gr, o.WT * 1.2, dt);
        var x = cx + Math.cos(o.a) * o.d + o.wx, y = cy + Math.sin(o.a) * o.d + o.wy;
        /* the caption appears only once the centred photo has landed (close to its spot and full size) */
        o.lb.classList.toggle('is-landed', i === center && o.d < 40 && Math.abs(o.s - o.ts) < .04);
        /* the centred product tilts less so its caption stays easy to read */
        damp(o, 'r', o.wr * (i === center ? .45 : 1), o.T, dt);
        var w = base * o.ar * o.s, h = base * o.s, l = x - w / 2, t = y - h / 2, rot = ' rotate(' + o.r.toFixed(3) + 'deg) ';
        var about = function (hw, hh) { return 'translate(' + hw.toFixed(2) + 'px,' + hh.toFixed(2) + 'px)' + rot; };
        o.el.style.transform = 'translate3d(' + l.toFixed(2) + 'px,' + t.toFixed(2) + 'px,0) ' + about(w / 2, h / 2) + 'translate(' + (-w / 2).toFixed(2) + 'px,' + (-h / 2).toFixed(2) + 'px) scale(' + o.s.toFixed(4) + ')';
        o.lb.style.transform = 'translate3d(' + l.toFixed(2) + 'px,' + t.toFixed(2) + 'px,0) ' + about(w / 2, h / 2) + 'translate(' + (-w / 2).toFixed(2) + 'px,' + (h / 2 + 12).toFixed(2) + 'px)';
        if (i === center) {
          var gw = w + PAD * 2, gh = h + PAD * 2;   /* frost fades out from the photo's edges only */
          glass.style.width = gw.toFixed(1) + 'px'; glass.style.height = gh.toFixed(1) + 'px';
          glass.style.transform = 'translate3d(' + (l - PAD).toFixed(2) + 'px,' + (t - PAD).toFixed(2) + 'px,0) ' + about(gw / 2, gh / 2) + 'translate(' + (-gw / 2).toFixed(2) + 'px,' + (-gh / 2).toFixed(2) + 'px)';
        }
      });
      if (first) { first = false; box.classList.add('is-ready'); }
    };
    els.forEach(function (el, i) {
      el.addEventListener('click', function (e) { if (i !== center) { e.preventDefault(); focus(i); } });
      el.addEventListener('focus', function () { if (el.matches(':focus-visible')) focus(i); });   /* keyboard only; a mouse click focuses first */
    });
    targets();
    if ('ResizeObserver' in window) new ResizeObserver(function () { targets(); }).observe(box); else window.addEventListener('resize', targets);
    requestAnimationFrame(function (t) { last = t; frame(t); });
  }

  var start = function () { initMenu(); initStage(); initMGrid(); initStudio(); initOrbit(); initProduct(); initCart(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
